import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-4 text-center text-sm text-gray-600">
      <p>
        Developed by{' '}
        <a 
          href="https://www.crimson.com.au/contact_us.htm" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-primary hover:text-primary-dark"
        >
          Crimson Innovations
        </a>
        {' '}and{' '}
        <a 
          href="https://digitaldarwin.com.au" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-primary hover:text-primary-dark"
        >
          DigitalDarwin
        </a>
      </p>
    </footer>
  );
}